import React from 'react';
import ReactDOM from 'react-dom/client';
import "swiper/css";
import './styles/font.css'
import './styles/index.css';
import { BrowserRouter as Router } from 'react-router-dom';

import App from "./App";
import { initAuthEtablissement } from "./store/initAuth";
import { initAuthProfessional } from "./store/initAuthProfessional";
import { initAuthPatient } from "./store/initAuthPatient";

const currentPath = window.location.pathname;
if (currentPath.startsWith("/etablissement")) {
  void initAuthEtablissement();
}
if (currentPath.startsWith("/professionnel") || currentPath.startsWith("/pro")) {
  void initAuthProfessional();
}
if (currentPath.startsWith("/patient")) {
  void initAuthPatient();
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);